import { Injectable } from "@angular/core"
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from "@angular/router"
import { AuthService } from "src/core/services/auth.service";
import { DashboardService } from "src/core/services/dashboard.service"
import { DashboardData, DashboardPayload } from "src/interfaces/dashboard";

@Injectable({
    providedIn: 'root'
})
export class DashboardResolver implements Resolve<any> {

    constructor(
        private _dashboardService: DashboardService,
        private _authService: AuthService,
        private _router: Router,
    ) { }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<{
        dates: {
            start: string,
            end: string
        },
        dashboardData: DashboardData | null
    }> {

        // get the recent month's data 
        const currentDate: Date = new Date();
        const startDate = new Date(currentDate.getFullYear(), 0, 2);
        const endDate = currentDate;

        const startDateString: string = startDate.toISOString().split('T')[0];
        const endDateString: string = endDate.toISOString().split('T')[0];

        const payload: DashboardPayload = {
            start_date: startDateString,
            end_date: endDateString,
            type: 'monthly',
            doctor_id: undefined,
            company_id: undefined,
        }

        if (!(await this._authService.isAuthenticatedAsync())) {

            return {
                dates: {
                    start: payload.start_date,
                    end: payload.end_date
                },
                dashboardData: null
            }
        }

        const dashboardData: DashboardData | null = await this._dashboardService
            .getDashboardData(payload);
        return {
            dates: {
                start: payload.start_date,
                end: payload.end_date
            },
            dashboardData
        }
    }
}